module.exports = __webpack_public_path__ + "img/logo.ca5ef8ef.png";